__turbopack_context__.v({
  "stepNavigation": "styles-module-scss-module__LDxFDa__stepNavigation",
  "stepNavigation__back": "styles-module-scss-module__LDxFDa__stepNavigation__back",
  "stepNavigation__continue": "styles-module-scss-module__LDxFDa__stepNavigation__continue",
  "stepNavigation__continueWrap": "styles-module-scss-module__LDxFDa__stepNavigation__continueWrap",
});
